import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'

import "./scss/element-#000000/index.css"

import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import locale from 'element-ui/lib/locale/lang/en'

import {
	rolesRouters,
	defaultRouter
} from './routes'

import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI, {
	locale
})
Vue.use(VueRouter)
Vue.use(Vuex)

Date.prototype.Format = function(fmt) {
	var o = {
		"M+": this.getMonth() + 1, //月份
		"d+": this.getDate(), //日
		"h+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度
		"S": this.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((
			"00" + o[
				k]).substr(("" + o[k]).length)));
	return fmt;
};
// Example: Generate Code Verifier and Challenge
function generateCodeVerifier() {
	const array = new Uint32Array(43);
	window.crypto.getRandomValues(array);
	return Array.from(array, dec => ('0' + dec.toString(16)).slice(-2)).join('');
}

async function generateCodeChallenge(codeVerifier) {
	const encoder = new TextEncoder();
	const data = encoder.encode(codeVerifier);

	const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);

	const hashArray = Array.from(new Uint8Array(hashBuffer));

	const base64 = btoa(String.fromCharCode.apply(null, hashArray))
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
		.replace(/=+$/, '');

	return base64;
}

const router = new VueRouter({
	mode: 'history',
	routes: rolesRouters.concat(defaultRouter)
})

router.beforeEach(async (to, from, next) => {
	// console.log(to, 'to')
	// console.log(from, 'from')
	const token = sessionStorage.getItem('token');

	if (!token && to.path != '/login_t' && to.path != '/sso') {
		
		if (to.query.id) {
			sessionStorage.setItem('id', to.query.id);
		}

		if(process.env.NODE_ENV === 'development') {
		  return next({path: '/login_t'})
		} else {
			const codeVerifier = generateCodeVerifier();
			const codeChallenge = await generateCodeChallenge(codeVerifier);
			sessionStorage.setItem('codeVerifier', codeVerifier);
			sessionStorage.setItem('codeChallenge', codeChallenge);
			const sso=`https://federation.corpnet4.com/as/authorization.oauth2?client_id=1ebc8f5353994ce5ad356e844972b67d&response_type=code&code_challenge=${codeChallenge}&code_challenge_method=S256`
			// console.log(sso,'sso')
			window.location.href = sso;
			return
		}
	}

	if (token && to.name === 'login') return next({path: '/select'})

	next()	
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js